import { createContext, useContext } from 'react';

const MapboxTokenContext = createContext(null);

export const MapboxTokenProvider = MapboxTokenContext.Provider;

export const useMapboxToken = () => useContext(MapboxTokenContext);
